import { render, staticRenderFns } from "./RecruitmentFormCourse.vue?vue&type=template&id=6f5cf150&"
import script from "./RecruitmentFormCourse.vue?vue&type=script&lang=js&"
export * from "./RecruitmentFormCourse.vue?vue&type=script&lang=js&"
import style0 from "./RecruitmentFormCourse.vue?vue&type=style&index=0&id=6f5cf150&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports